import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { startModifyForm } from '../../../redux/actions/form';
import { TitleBlock } from '../../../components/blocks/TitleBlock';
import { ActionBar } from '../../../components/toolbars/ActionBar';
import { ToggleOption } from '../../../components/inputs/ToggleOption';
import { ProgressBlock } from '../../../components/blocks/ProgressBlock';
import { FORM_TYPES, getStepData } from '../../../enums/Steps';
import {useLanguage} from "../../../hooks/useLanguage";

export const JourneyAgeForm = (props) => {
  const form = useSelector((state) => state.form[0]);
  const dispatch = useDispatch();
  const { t } = useLanguage();

  const step = 'age';
  const {  nextStep, prevStep, currentStepIndicator } = getStepData(
    step,
    FORM_TYPES.journey,
    t
  );

  const actionBarCopy = t('1_of_5');
  // const translatedActionBarCopy = actionBarCopy === '1_of_5' ? '1 of 5' : actionBarCopy

  const Ages = [
    {
      value: '<20',
      name:  t('<20'),
    },
    {
      value: '20-29',
      name:  t('20-29'),
    },
    {
      value: '30-39',
      name:  t('30-39'),
    },
    {
      value: '40-49',
      name:  t('40-49'),
    },
    {
      value: '50-59',
      name:  t('50-59'),
    },
    {
      value: '60-69',
      name:  t('60-69'),
    },
    {
      value: '70-79',
      name:  t('70-79'),
    },
    {
      value: '80-89',
      name:  t('80-89'),
    },
    {
      value: '90+',
      name:  t('90+'),
    },
  ];

  const Genders = [
    {
      value: 'male',
      name: t('male'),
      icon: 'male-icon',
    },
    {
      value: 'female',
      name: t('female'),
      icon: 'female-icon',
    },
  ];

  const handleAgeSelect = (age) => {
    dispatch(startModifyForm({ ...form, patientAge: age }));
  };

  const handleGenderSelect = (gender) => {
    dispatch(startModifyForm({ ...form, patientGender: gender }));
  };

  const [validation, setValidation] = useState(false);
  const validate = () => {
    setValidation(true);
  };


  return (
    <React.Fragment>
      <ProgressBlock value1={currentStepIndicator} value2={0} />
      <div className="inner-form-container">
        <TitleBlock copy={t('journey_age_question')} />
        <ToggleOption
          options={Ages}
          handleSelect={handleAgeSelect}
          selected={form.patientAge}
          validation={validation}
        />

        <TitleBlock copy={t('journey_sex_question')}></TitleBlock>
        <ToggleOption
          options={Genders}
          handleSelect={handleGenderSelect}
          selected={form.patientGender}
          validation={validation}
        />
      </div>
      <ActionBar
        prevState={prevStep}
        copy={actionBarCopy}
        handleValidation={validate}
        nextState={form.patientAge ? (form.patientGender ? nextStep : '') : ''}
      />
    </React.Fragment>
  );
};
